module.exports = __webpack_public_path__ + "img/home-society.d1ae5a20.png";